<div class="layout-wrapper">
  <app-unified-sidebar></app-unified-sidebar>
  <div class="aaaasf-container">
    <div class="layout--router">
      <div class="outlet-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
